import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function deviceId() {
  try {
    let id = localStorage.getItem("lux_device");
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem("lux_device", id);
    }
    return id;
  } catch (e) {
    return "";
  }
}

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "X-Requested-With": "LUX" },
});

api.interceptors.request.use((cfg) => {
  const d = deviceId();
  if (d) cfg.headers["X-Device-Id"] = d;
  return cfg;
});

export const media = (path) => {
  if (!path) return null;
  if (path.startsWith("http") || path.startsWith("data:")) return path;
  return `${BACKEND_URL}${path}`;
};

export const errMsg = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.response?.status === 429 ? "Too many attempts. Please wait a few minutes." : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || String(x)).join("; ");
  return fallback;
};

export const daysAgoText = (n) => {
  if (n === null || n === undefined) return "";
  if (n === 0) return "Verified today";
  if (n === 1) return "Verified 1 day ago";
  return `Verified ${n} days ago`;
};

export const fmtDate = (iso, withTime = false) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString("en-GB", withTime
    ? { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }
    : { day: "numeric", month: "short", year: "numeric" });
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const GENDER_LABEL = { woman: "Woman", man: "Man", trans: "Trans", nonbinary: "Non-binary" };
export const SERVICE_LABEL = { incall: "Incall", outcall: "Outcall" };
// Self-described ethnicity (UK census style). "prefer-not" is never shown publicly.
export const ETHNICITY_LABEL = {
  "white-british": "White British", "white-european": "White European", "black-african": "Black African", "black-caribbean": "Black Caribbean",
  indian: "Indian", pakistani: "Pakistani", chinese: "Chinese", arab: "Arab", "latin-american": "Latin American", mixed: "Mixed", other: "Other",
  "prefer-not": "Prefer not to say",
};
export const ETHNICITY_FILTERS = Object.entries(ETHNICITY_LABEL).filter(([k]) => k !== "prefer-not");
export const METHOD_LABEL = { phone: "Call", whatsapp: "WhatsApp", telegram: "Telegram", signal: "Signal" };
// What visitors will see on the public profile for each stored contact method (WhatsApp is shown whenever a mobile number exists)
export const METHOD_OPTION_LABEL = { whatsapp: "WhatsApp only", phone: "WhatsApp + Call", signal: "WhatsApp + Signal", telegram: "Telegram only (no WhatsApp)" };

export const fmtPrice = (price) => {
  if (!price || price.min == null || price.max == null) return null;
  return price.min === price.max ? `£${price.min}` : `£${price.min} – £${price.max}`;
};
